import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import routes from './router'
import Router from 'vue-router'
import {get,post} from '../store/vue_resource'
import VueResource from 'vue-resource'
import {hasBtn,removeByIndex,getTime,router_url,effect_list,api_imgurl,isMobile} from '../store/store'
var title_name='株式会社';
import 'swiper/css/swiper.css';
import ("@/assets/js/font.js");
import '@/assets/css/style.css';
import '@/assets/css/wapstyle.css';

import header_html from '@/components/header_html'
import footer_html from '@/components/footer_html'
import latest_property from '@/components/latest_property'

Vue.component('footer_html',footer_html);
Vue.component('header_html',header_html);
Vue.component('latest_property',latest_property);

Vue.prototype.$get = get
Vue.prototype.$post = post
Vue.prototype.removeByIndex = removeByIndex
Vue.prototype.getTime = getTime
Vue.prototype.hasBtn = hasBtn
Vue.prototype.title_name = title_name
Vue.prototype.isMobile = isMobile
Vue.prototype.router_url = router_url
Vue.use(VueResource)
Vue.use(ElementUI)
import vuescroll from "vuescroll";
Vue.component('vuescroll',vuescroll);





const router = new Router({
  routes,
  // scrollBehavior () {
  //   return { x: 0, y: 0 }
  // }
})

router.beforeEach((to, from, next) => {
	// if(to.hash.indexOf('#')==-1){
		window.scrollTo(0,0)
	// }
	if (to.path == '/') {
		next({
			path: '/index'
		})
	} else {
		next()
	}
})
new Vue({
	el: '#app',
	router,
	components: {
		App
	},
	template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js